import { render, staticRenderFns } from "./BasicFinancialTable.vue?vue&type=template&id=98d40026&"
import script from "./BasicFinancialTable.vue?vue&type=script&lang=js&"
export * from "./BasicFinancialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports